import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTION_CREATIVES_PAGINATED = gql`
  query campaignOrderTransactionCreativesPaginated(
    $where: CampaignOrderTransactionCreativesWhereInput!
    $first: Int
    $skip: Int
    $orderBy: CampaignOrderTransactionCreativesOrderByInput
  ) {
    campaignOrderTransactionCreativesesConnection(
      first: $first
      skip: $skip
      orderBy: $orderBy
      where: $where
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          media
          name
          impressions
          transactions
        }
      }
      aggregate {
        count
      }
    }
    full: campaignOrderTransactionCreativesesConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTION_CREATIVES_PAGINATED;
